import type { Perspective } from '../../types/perspective';
import { isPerspectiveSharingAvailable } from '../connections/connectionsDuck';
import { getDefaultPerspective } from '../perspectives/perspectives';
import { getPerspective } from '../perspectives/perspectives.selector';
import { getStartWithProvidedGraph } from '../scene/scene.selectors';
import type { RootState } from '../types';

export const getNextActivePerspectiveId = (state: RootState): string => {
  const isPlugin = isPerspectiveSharingAvailable(state);
  const providedGraph = getStartWithProvidedGraph(state);
  const perspective: Perspective | undefined = getPerspective(state);
  const defaultPerspective = getDefaultPerspective(state);
  if (providedGraph && !isPlugin && defaultPerspective) {
    return defaultPerspective.id;
  }
  return perspective?.id ?? '';
};
